import { useMemo, useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { CREATE_NOTES, EDIT_NOTES, HOME_EDUCATION_CLIENT_LIST, PRIVATE_CLIENT_LIST, SCHOOL_CLIENT_DETAIL, SCHOOL_CLIENT_LIST } from "config/paths";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
import { Breadcrumbs } from "components/Common/Common";
import CliniciansAssignedComponent from "./CliniciansAssignedComponent";
import { useGetSchoolClientDataQuery } from "store/services/clients/school.client";
import downArrow from "Assets/images/downArro.png"
import { store } from "store/store";
import { convertToMomentDate, dateFormat, getClientBreadCrumbs, userFullName } from "helpers/common";
import p1 from "Assets/images/user.png";
import { SERVICE_STATUS_OPTIONS } from "config/constants";
import { useClientsServiceStatusListQuery } from "store/services/utility";
import { useUpdateTherapistServiceStatusMutation } from "store/services/clientCaseLoads";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingOverlay from "components/shared/LoadingOverlay";
import { useGetHomeEducationDetailsQuery } from "store/services/clients/homeEducation";
import { useGetPrivateClientDetailsQuery } from "store/services/clients/private";
import { useChatterClientDetailsQuery } from "store/services/clients/chatter";


const ServiceStatusPage = () => {
    const state = store.getState();
    const user = state.auth.user;
    const navigate = useNavigate()
    const { clientId, moduleName, clientType } = useParams()


    const { data: clientDetails, isLoading, isFetching, refetch } = clientType == "school" ? useGetSchoolClientDataQuery(clientId) : clientType == "private" ? useGetPrivateClientDetailsQuery(clientId) : clientType == "chatter" ? useChatterClientDetailsQuery(clientId) : useGetHomeEducationDetailsQuery(clientId);
    const { data: serviceStatusList, isLoading: serviceStatusListLoading } = useClientsServiceStatusListQuery({ module: "client_service", client_type: clientType });
    const serviceStatusOptions = serviceStatusList?.map(i => ({ value: i.id, label: i.title }))?.filter((x) => x?.value != 181);;
    const [updateTherpaistServiceStatus, { isLoading: updateTherpaistServiceStatusLoading }] = useUpdateTherapistServiceStatusMutation()

    const clientBreadCrumb = clientType == "school" ? { label: "School Clients", path: SCHOOL_CLIENT_LIST } :
        clientType == "private" ? { label: "Private Clients", path: PRIVATE_CLIENT_LIST } :
            { label: "Home Education Clients", path: HOME_EDUCATION_CLIENT_LIST };

    // const breadcrumbItems = [
    //     clientBreadCrumb,
    //     { label: userFullName(clientDetails) || "Client Details", path: generatePath(SCHOOL_CLIENT_DETAIL, { id: clientId }) },
    //     { label: "Service Status" },
    // ];

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "Service Status"), [clientType, clientDetails, clientId]);


    const handleServiceStatus = async (id, therapistId) => {
        const payload = {
            service_status: id
        }
        try {
            await updateTherpaistServiceStatus({ payload, id: therapistId }).unwrap()
            refetch()
        } catch (error) {
            console.log("Error updating service status: ", error)
        }
    }

    return (
        <>
            {
                isLoading ? <LoadingIndicator /> :
                    <section
                        className={`position-relative ClientDetail`}
                    >
                        {(isFetching || updateTherpaistServiceStatusLoading) && <LoadingOverlay />}
                        <Container fluid>
                            <Row style={{ paddingLeft: '12px' }} className="pt-3">
                                <Col lg="6">
                                    <Breadcrumbs items={breadcrumbItems} />
                                </Col>
                            </Row>
                            <div className="mt-4" style={{ paddingLeft: '12px', borderRadius: "4px" }}>

                                <Row className="justify-content-between" >
                                    <Col lg='9'>
                                        <p className="twenty proxima-regular mb-0" style={{ color: "#000" }}>
                                            SERVICE STATUS
                                        </p>
                                    </Col>
                                </Row>
                            </div>
                            <div className="mt-2">
                                <table className="w-100">
                                    <thead>
                                        <tr>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                DATE
                                            </th>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                DISCIPLINE
                                            </th>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                CLINICAN
                                            </th>
                                            <th className="fw-medium " style={{ padding: "15px 10px", borderBottom: "2px solid #315D99" }}>
                                                STATUS
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            [...(clientDetails?.clientPendingCaseloads?.clientCaseloadTherapist ?? [])]
                                                ?.sort((a, b) => new Date(b?.updatedAt) - new Date(a?.updatedAt)) // SORT BY UPDATED AT (LATEST FIRST)
                                                ?.map((item, index) => {

                                                    const apprenticeFound = item?.clientCaseloadMapping?.find(x => x.caseTherapist?.therapist_detail?.type != "veteran")
                                                    const veteranFound = item?.clientCaseloadMapping?.find(x => x?.therapist_id == user.id);

                                                    return item?.clientCaseloadMapping?.map((caseloadMapping, index) => (
                                                        caseloadMapping?.caseTherapist?.therapist_detail?.type == "veteran" &&
                                                        <tr>
                                                            <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>{dateFormat(item?.updatedAt, "MMM D, YYYY")}</td>
                                                            <td className="" style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                <div>
                                                                    <span className={`discipline-${item?.caseDiscipline?.assign_term}-capsule-bcg`} style={{ padding: "7px 10px", marginRight: "3px", borderRadius: "8px" }}>{item?.caseDiscipline?.assign_term}</span>
                                                                </div>
                                                            </td>
                                                            <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>
                                                                {userFullName(caseloadMapping?.caseTherapist)}</td>
                                                            <td style={{ padding: "15px 10px", borderRadius: "0", borderBottom: "1px solid #8F8F8F" }}>

                                                                <Dropdown onSelect={(e) => handleServiceStatus(e, item?.id)}>
                                                                    <Dropdown.Toggle
                                                                        disabled={user.id != item?.clientCaseloadMapping?.[0]?.therapist_id || ['active', 'incoming']?.includes(clientDetails?.status) ? false : true}
                                                                        variant="light"
                                                                        id="custom-dropdown"
                                                                        style={{
                                                                            border: "1px solid #2a5ca3",
                                                                            backgroundColor: "#f6f9ff",
                                                                            color: "#2a5ca3",
                                                                            width: "200px",
                                                                            textAlign: "left",
                                                                        }}
                                                                    >
                                                                        {item?.caseServiceStatus?.title || "Select"}
                                                                    </Dropdown.Toggle>

                                                                    <Dropdown.Menu
                                                                        style={{
                                                                            width: "200px",
                                                                            padding: 0,
                                                                            borderRadius: "4px",
                                                                        }}
                                                                    >
                                                                        {serviceStatusOptions?.map((item, index) => (
                                                                            <Dropdown.Item
                                                                                key={index}
                                                                                // onClick={() => onSelect(item)}
                                                                                // active={selected === item}
                                                                                eventKey={item?.value}
                                                                                style={{
                                                                                    padding: "10px",
                                                                                    fontSize: "14px",
                                                                                    color: "#2a5ca3",
                                                                                }}
                                                                            >
                                                                                {item?.label}
                                                                            </Dropdown.Item>
                                                                        ))}
                                                                    </Dropdown.Menu>
                                                                </Dropdown>


                                                            </td>
                                                        </tr>
                                                    )
                                                    )
                                                })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </Container>
                    </section>
            }
        </>
    );

};

export default ServiceStatusPage;